var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDictionaryLanguageBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3216 24.1071H5.35728C4.64689 24.1071 3.96557 23.825 3.46325 23.3227C2.96093 22.8204 2.67871 22.1389 2.67871 21.4286C2.67871 20.7182 2.96093 20.0368 3.46325 19.5345C3.96557 19.0321 4.64689 18.75 5.35728 18.75H20.5359C21.0094 18.75 21.4637 18.5618 21.7985 18.227C22.1334 17.8921 22.3216 17.4379 22.3216 16.9643V2.67857C22.3216 2.20496 22.1334 1.75076 21.7985 1.41588C21.4637 1.08099 21.0094 0.892853 20.5359 0.892853H5.35728C4.65909 0.892605 3.98839 1.16499 3.48807 1.65197C2.98773 2.13896 2.69734 2.80205 2.67871 3.5V21.3571",
    stroke: "#2e5be0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5356 18.75V24.1071",
    stroke: "#2e5be0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.378 8.93204H18.512L14.1196 15.1331H18.7704",
    stroke: "#2e5be0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.271 10.6884L8.1746 4.97763C8.27219 4.68486 8.54616 4.4874 8.85476 4.4874C9.16337 4.4874 9.43735 4.68486 9.53492 4.97763L11.4385 10.6884M6.96 8.62143H10.7495",
    stroke: "#2e5be0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDictionaryLanguageBook);
export default __webpack_public_path__ + "static/media/icon_dictionary-language-book.db106e2c4e7b83debd0b93281b0f004d.svg";
export { ForwardRef as ReactComponent };